<template>
  <main-content>
    <TopBarDatePicker @datepicker="onReport" />

    <div class="col-12 mt-5">
      <div class="col-12">
        <TopStatistics />
      </div>

      <div class="col-12">
        <!-- v-if is set to false in the component -->
        <TopCountry
          @selectReport="onReport"
          title="Top 5 Countries"
        />
      </div>

      <div class="col-12">
        <div class="card-footer border-top p-5">
          <div class="row">
            <TopCountries :countries="countries" />
            <TopDevices :devices="devices" />
            <TopPlatorms :platorms="platforms" />
          </div>
          <!-- /.row -->
        </div>
      </div>
    </div>
  </main-content>
</template>


<script type="text/ecmascript-6">
import TopStatistics from "./components/TopStatistics.vue";
import TopBarDatePicker from "./components/TopBarDatePicker.vue";
import CountryBarChart from "./components/CountryBarChart.vue";
import TopCountry from "./components/TopCountry.vue";
import TopCountries from "./components/TopCountries.vue";
import TopPlatorms from "./components/TopPlatorms.vue";
import TopDevices from "./components/TopDevices.vue";
import { percentageData } from "@/plugins/utils";

import { FETCH_LISTENER_REPORT } from "@/store/action-types";
export default {
  components: {
    CountryBarChart,
    TopStatistics,
    TopBarDatePicker,
    TopCountry,
    TopCountries,
    TopPlatorms,
    TopDevices,
  },


  methods: {

    onReport(first, second){
      // this.stat = value
    //  console.log(value, end);
      this.invoke += 1

      if (typeof first == 'object') {
       // console.log('stats info', first); 
        this.report = first
      } else {
       // console.log('date', first, second);
        this.date = {start: first, end: second}
      }

    if (this.invoke > 1) {
       this.fetchListeners()
    }
     
    },

   async fetchListeners(){
      const query = {...this.date, ...this.report}

     // console.log(query);

      const data = await this.$store.dispatch(FETCH_LISTENER_REPORT, query);
    // console.log(data);
      this.platforms = percentageData(data.listeners, "platform");
      this.devices = percentageData(data.listeners, "device");
      this.countries = percentageData(data.listeners, "country_code");
   }
  },

  data() {
    return {
      date: {},
      report:{},
      invoke:0,
      countries: [],
      platforms: [],
      devices: [],
    };
  },
};
</script>

<style scoped>
.table th,
.table td {
  border-top-style: none;
  padding: 0;
}

.card-footer {
  background-color: white !important;
}
</style>

